import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import OfertaFB from "@/pages/OfertaFB";
import Success from "@/pages/Success";
import Cancel from "@/pages/Cancel";
import Analytics from "@/components/Analytics";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Analytics />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/oferta-fb" element={<OfertaFB />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FDFBF7",
            color: "#2A302A",
            border: "1px solid #E6E2D6",
            borderRadius: "16px",
          },
        }}
      />
    </div>
  );
}

export default App;
